import { Colors } from "@dotnet/telematics-design-system";

import { ResourceDownloadsStatus } from "../../LeftSide/ResourceDownloads/types";
import { DeviceStatus } from "./types/enums";

export const statusColor = (itemName: string, colors: Colors) => {
  switch (itemName) {
    case DeviceStatus.Online:
    case ResourceDownloadsStatus.OnTime:
      return colors.green700;

    case DeviceStatus.Offline:
    case ResourceDownloadsStatus.Overdue:
      return colors.red700;

    case DeviceStatus.Inactive:
      return colors.white;

    case ResourceDownloadsStatus.NoDownloads:
    case DeviceStatus.Deactivated:
      return colors.gray200;

    case ResourceDownloadsStatus.DueSoon:
      return colors.orange400;
    default:
      return "";
  }
};

export const statusBorderColor = (itemName: string, colors: Colors) => {
  switch (itemName) {
    case DeviceStatus.Online:
    case ResourceDownloadsStatus.OnTime:
      return colors.green700;

    case DeviceStatus.Offline:
    case ResourceDownloadsStatus.Overdue:
      return colors.red700;

    case DeviceStatus.Inactive:
      return colors.gray400;

    case DeviceStatus.Deactivated:
    case ResourceDownloadsStatus.NoDownloads:
      return colors.gray400;

    case ResourceDownloadsStatus.DueSoon:
      return colors.orange400;
    default:
      return "";
  }
};

export const hoveredElementToRealIndex = (hoveredElement: number | null) => {
  switch (hoveredElement) {
    case 0:
      return 0;
    case 2:
      return 1;
    case 4:
      return 2;
    case 6:
      return 3;
    default:
      return null;
  }
};
